import {NgModule} from '@angular/core';
import {ArticleBlockMetadataComponent} from './article-block-metadata.component';
import {ArticleBlockMetadataButtonComponent} from './article-block-metadata-button/article-block-metadata-button.component';
import {CommonModule} from '@angular/common';
import {IconModule} from '@tisa-group/client-ui/components/icon';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [ArticleBlockMetadataComponent, ArticleBlockMetadataButtonComponent],
  exports: [ArticleBlockMetadataComponent, ArticleBlockMetadataButtonComponent],
  imports: [CommonModule, IconModule, RouterModule],
})
export class ArticleBlockMetadataModule {}
